import { render, staticRenderFns } from "./MajorityVote.vue?vue&type=template&id=5ec1dfed&"
import script from "./MajorityVote.vue?vue&type=script&lang=js&"
export * from "./MajorityVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports